import ChangePermission from "@pages/profile-v2/pages/profile/containers/ChangePermission";
import RealityCheck from "@pages/profile/realityCheck.jsx";
import SelfExclusion from "@pages/profile/selfExclusion.jsx";
import TwoFactorAuth from "@pages/profile/twoFactorAuth/twoFactorAuth.jsx";
import React from "react";
import ChangeLanguage from "./containers/ChangeLanguage";
import ChangePassword from "./containers/ChangePassword";
import UserInformation from "./containers/UserInformation";
import { Wrapper } from "./elements";

const ProfilePage = ({ translate, user, updateUserInfo, toggleLoading }) => {
	return (
		<>
			<UserInformation translate={translate} />
			<Wrapper>
				<ChangePassword
					user={user}
					translate={translate}
					updateUserInfo={updateUserInfo}
				/>
				<ChangePermission
					user={user}
					translate={translate}
					updateUserInfo={updateUserInfo}
				/>
			</Wrapper>
			<Wrapper>
				<ChangeLanguage />
				<TwoFactorAuth
					toggleLoading={toggleLoading}
					enabled={user?.mfa_enabled}
				/>
			</Wrapper>
			<Wrapper>
				<SelfExclusion user={user} />
				<RealityCheck />
			</Wrapper>
		</>
	);
};

export default ProfilePage;
